/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $TermsAndConditionList = {
    type: 'array',
    contains: {
        type: 'TermsAndCondition',
    },
};